export const locale = {
  lang: 'pt',
  data: {
    'TEMPLATE':{
      'PANT_TEMPLATE':{
        'INST_1': 'Descarregar o modelo de pergunta',
        'INST_2': 'Fazer as alterações necessárias ao modelo',
        'INST_3': 'Carregar o modelo de pergunta',
        'BTN_DESC_PLAN': 'Template de Perguntas',
        'BUSC_PLAN_TEX': 'Clique aqui para pesquisar o modelo de perguntas',
        'TEMP_CARG_TIT': 'Informação sobre o modelo',
        'TOT_PREG': 'Perguntas totais',
        'TOT_PREG_MODI': 'Perguntas totalmente modificadas',
        'TOT_PREG_NUE': 'Total de novas perguntas',
        'TEMP_CARG_TIT_CAR': 'Template information loaded',
        'COMPL_PAS_SIN_MODI':'Ainda não fez nenhuma modificação. Tem a certeza de completar o passo?',
        'SUCC_CAR_PLAN':'O modelo foi carregado com sucesso. Por favor, complete o passo',
        'COMPLE_PASO_CON_MODI': 'Tem a certeza de completar o passo com as alterações actualmente introduzidas?',
        'NO_MODIF':'Não modifique o conteúdo desta célula',
        'ERROR_CARGA':'O arquivo não pode ser carregado, foram detectadas modificações em uma ou mais células restritas, baixe o modelo novamente e faça as modificações desejadas sem modificar as células restritas.\n\nAs células restritas contêm um comentário indicando que seu conteúdo não deve ser modificado',
        'FORALL_EXCEDIDAS': 'Foi detectado que o número de práticas 4Todas presentes no template carregado excede o número de práticas permitidas, apenas as práticas que correspondem ao máximo permitido foram carregadas ',
        'OPCIONDEMOGRAFICOS': 'Esta célula deve conter um valor inalterado da folha do catálogo demográfico',
        'CARGANDO_PREGUNTAS': 'Carregando perguntas do modelo'
      },
      'CATALOGO_IDIOMAS':{
        'z1': 'Chinês Simplificado',
          'z2': 'Chinês Tradicional',
          'ko': 'Coreano',
          'ja': 'japonês',
          'pt':'Português',
          'en':'Inglês',
          'fr':'francês',
          'de':'Alemão',
          'it': 'italiano',
          'es':'Espanhol',
          'tr':'Turco',
          'ms': 'Malaio',
          'ro': 'romeno',
          'vi': 'vietnamita',
          'bg': 'búlgaro',
          'olá': 'Hindi',
          'ru': 'Russo',
          'mn': 'Mongol',
          'nl': 'holandês',
          'ar': 'árabe',
          'ua': 'ucraniano',
          'id': 'indonésio',
      },
      'HOJAS_EXCEL':{
      'Instrucciones': 'Instructions',
      'Catalogo': 'Catálogo',
      'Detalles': 'Detalhes',
      'CatDemograficos': 'Catálogo Demográfico',
      'Nps': 'Nps',
      'Reactivos': 'Declarações',
      'Control': 'Controlo',
      'Demográficos': 'Demográficos',
      'Abiertas': 'Aberto',
      'Forall': 'Forall',
      'Adicionales': 'Adicionales',
     },
     'COLUMNAS_H_CATA':{
     'ClaveIdiomas': 'LanguageKey',
     'NombreIdiomas': 'LanguageName',
     'IDTipoPregunta': 'Identificação do tipo de pergunta',
     'TiposPreguntas': 'Tipos de perguntas',
     'ClaveTipoElemento': 'Chave tipo elemento',
     'TiposElementos': 'Tipos de elementos',
       'CONTEM_TIP_PREG':{
         '1': 'NPS / Controlo / Pergunta adicional (escolha múltipla, uma resposta)',
         '2_1': 'NPS / Controlo / pergunta aberta, tipo de texto aberto',
         '2_2': 'NPS / Controlo / pergunta aberta, tipo de texto numérico',
         '3': 'Pergunta de tipo reactivo',
         '4': 'Pergunta de tipo demográfico (escolha múltipla, uma resposta)',
         '5':'Pratique 4All',
         '6': 'Pergunta adicional (escolha múltipla, respostas múltiplas)',
       },
       'CONTEM_TIP_SEGM':{
       'question': 'Texto da pergunta',
       'answer_1': 'Texto da resposta 1',
       'answer_2': 'Texto da resposta 2',
       'answer_n': 'Texto da resposta n',
       'practice': 'Texto da prática 4All',
       'description': 'Texto de descrição da prática 4All',
       'statement_1': 'Pergunta 1 da prática 4All',
       'statement_2': 'Pergunta 2 da prática 4All',
       }
     },
     'COLUMNAS_SECCION':{
     'Id': 'Id',
     'TipoDePregunta': 'QuestionType',
     'PalabrasClave': 'KeyWords',
     'NuevaPregunta': 'NewQuestion',
     'Eliminable':	'Eliminável',
     'Editable':	'editável',
     'RespuestaObligatoria':'CompulsoryAnswer',
     'MostrarPregunta': 'ShowQuestion',
     'Dimension': 'Dimensão',
     'Competencia':	'Competência',
     'Subcompetencia':	'Subcompetência',
     'TipoDemográfico': 'TipoDemográfico',
     'practice': 'praticar',
     'description': 'descrição',
     'statement_1': 'statement_1',
     'statement_2': 'statement_2',
     'question': 'pergunta',
     'answer': 'resposta',
     'OpcionOtro': 'Tipo de resposta "Outro"'

     }
    }
  }
};
